export const DASHBOARD_CURVE_OFFSETS = [7, 14, 30, 90, 180, 365, 730] as const;
export type DashboardCurveOffset =
  | 'previous'
  | (typeof DASHBOARD_CURVE_OFFSETS)[number];
export interface CurveDateRange {
  start: string;
  end: string;
}

const DAY = 86400000;
const day = (iso: string) => Date.parse(`${iso.slice(0, 10)}T00:00:00Z`);
const iso = (time: number) => new Date(time).toISOString().slice(0, 10);

/** Compare equal-length windows. An offset is historical, never a trailing range ending today. */
export function dashboardCurveRange(
  start: string,
  end: string,
  offset: DashboardCurveOffset,
): CurveDateRange {
  const first = day(start),
    last = day(end);
  const shift = offset === 'previous' ? (last - first) / DAY + 1 : offset;
  return {start: iso(first - shift * DAY), end: iso(last - shift * DAY)};
}
